import { System } from './../../shared-components/System';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { YearService } from '../../shared-components/year/year.service';
import { UserService } from '../../shared-components/user/user.service';
import { StudentService } from '../../shared-components/student/student.service';
import { Announcement } from './announcement.model';
import { MatDialog } from '@angular/material/dialog';
import {BroadcastDialogComponent} from './broadcast-dialog/broadcast-dialog.component';
import {LoginService} from '../login/login.service';
import {take} from 'rxjs/operators';

// Class
@Injectable ()
export class AnnouncementService {

    // Properties
    checkingBroadcast = false;

    // Class Functions
    constructor (
        private http: HttpClient,
        private userService: UserService,
        private yearService: YearService,
        private studentService: StudentService,
        private dialog: MatDialog,
        private loginService: LoginService
    ) { }

    // Event Functions
    checkBroadcast () {
        // POST: waits for the student broadcast

        // We only want to do this one and if the system setting is set
        if (!this.checkingBroadcast && this.loginService.LoginSettings.ActivateBroadcast) {
            this.checkingBroadcast = true;

            // Setting up query string
            const queryString = '?yearId=' + this.yearService.defaultYear.Id +
                '&userId=' + this.userService.currentUser.Id;
            let call: string;
            switch (this.userService.currentUser.UserType) {
                case 1:
                    call = 'CheckBroadcastStaff';
                    break;
                case 2:
                    call = 'CheckBroadcastParent';
                    break;
                case 3:
                    call = 'CheckBroadcastStudent';
                    break;
            }

            // Checking the broadcast upon initialization
            this.http.get<Announcement[]>(System.apiURL.Student + call + queryString).pipe(take(1)).subscribe(
                broadcasts => {
                    if (broadcasts) {
                        broadcasts.forEach(broadcast => {
                            this.dialog.open(BroadcastDialogComponent, {
                                disableClose: true,
                                data: {
                                    broadcast: broadcast
                                }
                            });
                        });
                    }
                }
            );

            // Setting the interval for checking broadcast
            setInterval(() => {
                this.http.get<Announcement[]>(System.apiURL.Student + call + queryString).pipe(take(1)).subscribe(
                    broadcasts => {
                        if (broadcasts) {
                            broadcasts.forEach(broadcast => {
                                this.dialog.open(BroadcastDialogComponent, {
                                    disableClose: true,
                                    data: {
                                        broadcast: broadcast
                                    }
                                });
                            });
                        }
                    }
                );
            }, this.loginService.LoginSettings.BroadcastInterval * 1000);
        }
    }

    // Methods
    getStaffAnnouncements (currentDate: Date): Observable<Announcement[]> {
        // PRE: the route requires the user's id, the school's id, the year's id, and date of inquiry as a string formatted mm/dd/yy
        // POST: returns all staff announcements for the user of a given school during a given year at a given date
        const dateString = (currentDate.getMonth() + 1) + '/' + (currentDate.getDate()) + '/' + (currentDate.getFullYear().toString().slice(2));
        return this.http.get<Announcement[]>(
            System.apiURL.Student +
            'GetStaffAnnouncements' +
            '?userId=' + this.userService.currentUser.Id +
            '&schoolId=' + this.yearService.defaultYear.SchoolID +
            '&yearId=' + this.yearService.defaultYear.Id +
            '&currentDate=' + dateString
        );
    }

    getStudentAnnouncements (currentDate): Observable<Announcement[]> {
        // PRE: the route requires the student's id, the year's id, the user's id, the date of inquiry as a string formatted mm/dd/yy, and whether or not this is mobile
        // POST: returns all student announcements for the given student as a given user during a given year at a given date. Mobile changes the format (I think?).
        const dateString = (currentDate.getMonth() + 1) + '/' + (currentDate.getDate()) + '/' + (currentDate.getFullYear().toString().slice(2));
        return this.http.get<Announcement[]>(
            System.apiURL.Student +
            'GetStudentAnnouncements' +
            '?studentId=' + this.studentService.selectedStudent.Id +
            '&yearId=' + this.yearService.defaultYear.Id +
            '&userId=' + this.userService.currentUser.Id +
            '&currentDate=' + dateString  +
            '&isMobile=false' // TODO: make this a function
        );
    }
}
